import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiGet, apiPost } from "../../../API/Api_Url";
import { FaUsers, FaTrashAlt, FaEye, FaTrash } from "react-icons/fa";
import { FaEdit } from "react-icons/fa";
import { DollarSign, MapPin, Calendar } from "lucide-react";
import { toast } from "react-toastify";
import FreelancerAddQuotationModel from "../../Modal/FreelancerAddQuotationModel";
import FreelancerUpdateQuotationModal from "../../Modal/FreelancerUpdateQuotationModal";
import FreelancerDeleteQuotationModal from "../../Modal/FreelancerDeleteQuotationModal";

function AllPendingJobPost({ ProUserdata }) {
    const navigate = useNavigate();
    const [JobPost, setJobPost] = useState([]);
    const [isUploading, setIsUploading] = useState(false);

    const GetAllPendingJobPosts = async () => {
        try {
            const City = ProUserdata?.City || "";

            setIsUploading(true);
            const response = await apiGet(
                `api/freelance-engineer/FreelancerGetAllPendingJobPost?state=&city=${encodeURIComponent(City)}&skill=`
            );

            if (response?.data) {
                setJobPost(response.data);
            } else {
                setJobPost([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setJobPost([]);
        } finally {
            setIsUploading(false);
        }
    };

    useEffect(() => {
        if (ProUserdata) {
            GetAllPendingJobPosts();
        }
    }, [ProUserdata]);

    const getStatusColor = (status) => {
        switch (status) {
            case "Pending":
                return "bg-yellow-100 text-yellow-800 border-yellow-200";
            case "Accepted":
                return "bg-green-100 text-green-800 border-green-200";
            case "Rejected":
                return "bg-red-100 text-red-800 border-red-200";
            default:
                return "bg-gray-100 text-gray-800 border-gray-200";
        }
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
        });
    };

    const [Quotation, setQuotation] = useState(null);
    const [QuotationError, setQuotationError] = useState(null);
    const [IsQuotationLoading, setIsQuotationLoading] = useState(false);

    const GetQuotationofAJobPost = async (id) => {
        try {
            setIsQuotationLoading(true);
            setQuotation(null);
            setQuotationError(null);

            const response = await apiGet(`api/freelance-engineer/GetBidofAJobPost/${id}`);

            if (response?.statusCode === 200) {
                setQuotation(response?.data);
            } else {
                setQuotationError(response?.message || "No Quotation found");
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setQuotationError("Error fetching Quotation");
        } finally {
            setIsQuotationLoading(false);
        }
    };



    const [expandedJob, setExpandedJob] = useState(null);

    const toggleQuotations = async (reqId) => {
        if (expandedJob === reqId) {
            setExpandedJob(null);
            setQuotation(null);
            setQuotationError(null);
        } else {
            await GetQuotationofAJobPost(reqId);
            setExpandedJob(reqId);
        }
    };

    const [SelectedQuotation, setSelectedQuotation] = useState(null);
    const [UpdateQuotationModel, setUpdateQuotationModel] = useState(false);

    const OpenUpdateQuotationModel = (req) => {
        setUpdateQuotationModel(true)
        setSelectedQuotation(req)
    }

    const CloseUpdateQuotationModel = () => {
        setUpdateQuotationModel(false)
        setSelectedQuotation(null)
    }

    const [DeleteQuotationModel, setDeleteQuotationModel] = useState(false);

    const OpendeleteQuotationModel = (req) => {
        setSelectedQuotation(req)
        setDeleteQuotationModel(true)
    }

    const CloseDeleteQuotationModel = () => {
        setDeleteQuotationModel(false)
        setSelectedQuotation(null)
    }


    const [AddQuotationModel, setAddQuotationModel] = useState(false);
    const [SelectedReq, setSelectedReq] = useState(null);

    const OpenAddQuotationModel = (req) => {
        setSelectedReq(req)
        setAddQuotationModel(true)
    }

    const CloseAddQuotationModel = () => {
        setSelectedReq(null)
        setAddQuotationModel(false)
    }



    return (
        <div className="p-6 bg-gradient-to-br from-blue-50 to-indigo-100 min-h-screen">
            <div className="max-w-7xl mx-auto">
                <div className="mb-8 flex flex-col md:flex-row md:items-center md:justify-between">
                    <div>
                        <h1 className="text-3xl font-bold text-gray-900 mb-1 md:mb-0">
                            All Pending Freelancer Job Posts
                        </h1>
                        <p className="text-gray-600">Manage and track your freelancer job posts</p>
                    </div>
                </div>

                {isUploading ? (
                    <div className="flex items-center justify-center py-20">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
                        <p className="ml-4 text-gray-600">Loading pending requirements...</p>
                    </div>
                ) : JobPost?.length === 0 ? (
                    <div className="text-center py-20">
                        <p className="text-xl text-gray-500">No pending job requirements found.</p>
                        <p className="text-gray-400 mt-2">You don’t have any pending jobs right now.</p>
                    </div>
                ) : (
                    <div className="grid gap-6 grid-cols-1">
                        {JobPost?.map((req) => (
                            <div key={req?._id} className="bg-white rounded-2xl shadow-lg p-6">
                                <div className="flex justify-between items-start mb-4">
                                    <h3 className="text-xl font-bold text-gray-900">{req?.Title}</h3>
                                    <span className={`px-3 py-1 text-xs font-semibold rounded-full border ${getStatusColor(req?.Status)}`}>
                                        {req?.Status}
                                    </span>
                                </div>

                                <p className="text-gray-700 mb-3">{req?.Description}</p>

                                {req?.Skillsrequire?.length > 0 && (
                                    <p className="text-sm text-gray-600 mb-3">
                                        <span className="font-medium">Skills Required:</span>{" "}
                                        {req?.Skillsrequire.join(", ")}
                                    </p>
                                )}

                                <div className="grid grid-cols-2 gap-4 text-sm mb-4">
                                    <div className="flex items-center text-gray-700">
                                        <DollarSign className="h-4 w-4 mr-2 text-purple-500" />
                                        <p>
                                            <span className="font-medium">Budget:</span> ₹{req?.Budget}
                                        </p>
                                    </div>

                                    <div className="flex items-center text-gray-700">
                                        <Calendar className="h-4 w-4 mr-2 text-orange-500" />
                                        <p>
                                            <span className="font-medium">Timeline:</span>{" "}
                                            {formatDate(req?.timeline?.startDate)} - {formatDate(req?.timeline?.endDate)}
                                        </p>
                                    </div>
                                </div>
                                {req?.location && (
                                    <div className="flex items-start text-gray-600 mb-4">
                                        <MapPin className="h-4 w-4 mr-2 mt-0.5 text-blue-500" />
                                        <p className="text-sm">
                                            {req?.location?.Address}, {req?.location?.City}, {req?.location?.State}
                                        </p>
                                    </div>
                                )}
                                <div className="mt-6 flex justify-between items-center text-sm text-gray-500">
                                    <span className="flex items-center">
                                        <Calendar className="h-4 w-4 mr-1" />
                                        Created: {formatDate(req?.createdAt)}
                                    </span>

                                    <div className="flex items-center gap-2">
                                        <button className="flex items-center gap-1 px-3 py-1 text-sm bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition">
                                            <FaEye className="h-4 w-4" /> View Details
                                        </button>
                                    </div>

                                    <button
                                        onClick={() => toggleQuotations(req?._id)}
                                        className="mt-3 text-sm text-blue-600 hover:underline flex items-center gap-2"
                                        disabled={IsQuotationLoading}
                                    >
                                        {IsQuotationLoading && expandedJob === req?._id ? (
                                            <>
                                                <div className="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                                                <span>Loading...</span>
                                            </>
                                        ) : expandedJob === req?._id ? (
                                            "Hide My Quotations"
                                        ) : (
                                            "Show My Quotations"
                                        )}
                                    </button>
                                </div>
                                {expandedJob === req?._id && (
                                    <div className="mt-3 border-t pt-3">
                                        {IsQuotationLoading ? (
                                            <p className="text-gray-500 text-sm">Loading Quotation...</p>
                                        ) : Quotation ? (
                                            <div className="bg-white rounded-xl shadow-md p-4 border border-gray-200">
                                                <h4 className="text-lg font-semibold text-gray-800 mb-3">
                                                    My Quotation
                                                </h4>

                                                <div className="space-y-3 bg-gray-50 p-3 rounded-lg border">
                                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
                                                        <div>
                                                            <span className="font-medium text-gray-600">Proposed Price:</span>{" "}
                                                            ₹{Quotation?.ProposedPrice}
                                                        </div>
                                                        <div>
                                                            <span className="font-medium text-gray-600">Start Date:</span>{" "}
                                                            {new Date(Quotation?.Timeline?.startDate).toLocaleDateString()}
                                                        </div>
                                                        <div>
                                                            <span className="font-medium text-gray-600">End Date:</span>{" "}
                                                            {new Date(Quotation?.Timeline?.endDate).toLocaleDateString()}
                                                        </div>
                                                        <div>
                                                            <span className="font-medium text-gray-600">Note:</span>{" "}
                                                            {Quotation?.Note}
                                                        </div>
                                                        <div>
                                                            <span className="font-medium text-gray-600">Status:</span>{" "}
                                                            <span
                                                                className={`px-2 py-0.5 rounded-md text-xs font-medium ${Quotation?.Status === "Pending"
                                                                    ? "bg-yellow-100 text-yellow-700"
                                                                    : Quotation?.Status === "Approved"
                                                                        ? "bg-green-100 text-green-700"
                                                                        : "bg-red-100 text-red-700"
                                                                    }`}
                                                            >
                                                                {Quotation?.Status}
                                                            </span>
                                                        </div>
                                                        <div>
                                                            <span className="font-medium text-gray-600">Created:</span>{" "}
                                                            {new Date(Quotation?.createdAt).toLocaleString()}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="mt-4 flex justify-end gap-3">
                                                    <button
                                                        onClick={() => OpenUpdateQuotationModel(Quotation)}
                                                        className="flex items-center gap-1 px-3 py-1.5 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700 transition"
                                                    >
                                                        <FaEdit className="text-xs" /> Update
                                                    </button>
                                                    <button
                                                        onClick={() => OpendeleteQuotationModel(Quotation)}
                                                        className="flex items-center gap-1 px-3 py-1.5 bg-red-600 text-white text-sm rounded-md hover:bg-red-700 transition"
                                                    >
                                                        <FaTrash className="text-xs" /> Delete
                                                    </button>
                                                </div>
                                            </div>
                                        ) : QuotationError ? (
                                            <button
                                                onClick={() => OpenAddQuotationModel(req)}
                                                className="px-3 py-1.5 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700"
                                            >
                                                Create Quotation
                                            </button>
                                        ) : null}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </div>
            <FreelancerAddQuotationModel
                isOpen={AddQuotationModel}
                onClose={CloseAddQuotationModel}
                JobPostData={SelectedReq}
                GetAllPendingJobs={GetAllPendingJobPosts}
                setExpandedJob={setExpandedJob}
            />
            <FreelancerUpdateQuotationModal
                isOpen={UpdateQuotationModel}
                onClose={CloseUpdateQuotationModel}
                JobPostData={SelectedQuotation}
                GetAllPendingJobs={GetAllPendingJobPosts}
                setExpandedJob={setExpandedJob}
            />

            <FreelancerDeleteQuotationModal
                isOpen={DeleteQuotationModel}
                onClose={CloseDeleteQuotationModel}
                JobPostData={SelectedQuotation}
                GetAllPendingJobs={GetAllPendingJobPosts}
                setExpandedJob={setExpandedJob}
            />

        </div>

    );
}

export default AllPendingJobPost;
